// The four free Women's Den guides (PDFs in /public/guides, covers rendered
// from each PDF's first page). Guide titles stay in English in both languages
// because the guides themselves are written in English.
//
// DUTCH SLOT: to add Dutch translations later, drop the translated files at
//   /public/guides/nl/<same-filename>.pdf          (the Dutch PDF)
//   /public/guides/covers/nl/<same-filename>.jpg   (its cover)
// and redeploy — no code changes needed. The site serves the Dutch file when
// it exists and quietly falls back to the English one until then (frontend
// and backend resolve this independently, so emails get the right link too).
export const GUIDES = [
  {
    id: "growing-up-and-periods",
    title: { en: "Growing Up & Periods", nl: "Growing Up & Periods" },
    sub: { en: "A guide for parents", nl: "Een gids voor ouders" },
    pdf: { en: "/guides/growing-up-and-periods.pdf", nl: "/guides/nl/growing-up-and-periods.pdf" },
    cover: { en: "/guides/covers/growing-up-and-periods.jpg", nl: "/guides/covers/nl/growing-up-and-periods.jpg" },
  },
  {
    id: "preparing-for-birth",
    title: { en: "Preparing for Birth", nl: "Preparing for Birth" },
    sub: { en: "Before Labour Begins", nl: "Vóór de bevalling begint" },
    pdf: { en: "/guides/preparing-for-birth.pdf", nl: "/guides/nl/preparing-for-birth.pdf" },
    cover: { en: "/guides/covers/preparing-for-birth.jpg", nl: "/guides/covers/nl/preparing-for-birth.jpg" },
  },
  {
    id: "who-is-caring-for-you",
    title: { en: "Who Is Caring for You?", nl: "Who Is Caring for You?" },
    sub: { en: "A small guide for the months after birth", nl: "Een kleine gids voor de maanden na de geboorte" },
    pdf: { en: "/guides/who-is-caring-for-you.pdf", nl: "/guides/nl/who-is-caring-for-you.pdf" },
    cover: { en: "/guides/covers/who-is-caring-for-you.jpg", nl: "/guides/covers/nl/who-is-caring-for-you.jpg" },
  },
  {
    id: "something-is-changing",
    title: { en: "Something Is Changing", nl: "Something Is Changing" },
    sub: { en: "A Perimenopause Reflection Guide", nl: "Een reflectiegids voor de perimenopauze" },
    pdf: { en: "/guides/something-is-changing.pdf", nl: "/guides/nl/something-is-changing.pdf" },
    cover: { en: "/guides/covers/something-is-changing.jpg", nl: "/guides/covers/nl/something-is-changing.jpg" },
  },
];

export const guideById = (id) => GUIDES.find((g) => g.id === id);

// Resolve the language-specific asset, falling back to English when the Dutch
// file is not present yet. The SPA/static host answers missing files with
// index.html (200), so we verify the content type, not just the status.
const _assetCache = {};
export const resolveGuideAsset = async (guide, lang, kind) => {
  const wanted = (guide[kind] || {})[lang] || guide[kind].en;
  if (lang !== "nl") return guide[kind].en;
  if (_assetCache[ wanted ] !== undefined) return _assetCache[wanted];
  try {
    const r = await fetch(wanted, { method: "HEAD" });
    const ct = r.headers.get("content-type") || "";
    const ok = r.ok && (kind === "pdf" ? ct.includes("pdf") : ct.includes("image"));
    _assetCache[wanted] = ok ? wanted : guide[kind].en;
  } catch {
    _assetCache[wanted] = guide[kind].en;
  }
  return _assetCache[wanted];
};

export const GUIDE_COPY = {
  en: {
    heading: "Something to take with you",
    intro: "A small collection of guides for some of the thresholds we don't always know how to prepare for.",
    receive: "Receive the guide",
    emailLabel: "Email address",
    emailPlaceholder: "you@example.nl",
    slowLetter: "I'd also like to receive the Women's Den Slow Letter, about once a month.",
    send: "Send",
    sending: "Sending…",
    success: "On its way to your inbox — you can also open it directly:",
    open: "Open the guide",
    error: "Something went wrong — please try again in a moment.",
    privacyNote: "Your email address is used only to send you this guide.",
    privacyLink: "Read our privacy policy",
    englishNote: "Written in English.",
  },
  nl: {
    heading: "Iets om mee te nemen",
    intro: "Een kleine verzameling gidsen voor een paar van de overgangen waarvoor we niet altijd weten hoe we ons kunnen voorbereiden.",
    receive: "Ontvang de gids",
    emailLabel: "E-mailadres",
    emailPlaceholder: "jij@voorbeeld.nl",
    slowLetter: "Ik ontvang ook graag de Women's Den Slow Letter, ongeveer één keer per maand.",
    send: "Verstuur",
    sending: "Versturen…",
    success: "Onderweg naar je inbox — je kunt de gids ook direct openen:",
    open: "Open de gids",
    error: "Er ging iets mis — probeer het over een moment opnieuw.",
    privacyNote: "Je e-mailadres wordt alleen gebruikt om je deze gids te sturen.",
    privacyLink: "Lees ons privacybeleid",
    englishNote: "In het Engels geschreven.",
  },
};
